import React, { FC } from "react";
import MUIDivider, { DividerProps } from "@mui/material/Divider";

export const Divider: FC<DividerProps> = (props) => <MUIDivider {...props} />;
